import type { Venue } from '../../types/venue';

export const steamHotel: Venue = {
  id: 'steam-hotel',
  name: 'Steam Hotel',
  description: {
    en: `<p>Forget everything you associate with the word conference. At Steam Hotel, you'll meet in a unique industrial-romantic environment on the shores of Lake Mälaren, just 55 minutes from Stockholm. Besides charming meeting facilities and world-class refreshments, we offer plenty of activities to build team spirit. Small-scale or grand? We got you. Up to 450 people, zero technical issues, and a maxed-out experience.</p>`,
    
    sv: `<p>Glöm allt du förknippar med ordet konferens. På Steam Hotel möts ni en unik industriromantisk miljö vid Mälarens kant, bara 55 minuter från Stockholm. Förutom charmiga möteslokaler och fika i världsklass, erbjuder vi mängder av aktiviteter för att bygga teamkänsla. Småskaligt eller storslaget? We got you. Upp till 450 personer, noll teknikstrul och en maxad upplevelse.</p>`,
    
    no: `<p>Glem alt du forbinder med ordet konferanse. På Steam Hotel møtes du i et unikt industriromantisk miljø ved bredden av Mälaren, bare 55 minutter fra Stockholm. Foruten sjarmerende møtelokaler og forfriskninger i verdensklasse, tilbyr vi masse aktiviteter for å bygge teamfølelse. Småskala eller storslått? We got you. Opp til 450 personer, null tekniske problemer og en maksimal opplevelse.</p>`,
    
    da: `<p>Glem alt hvad du forbinder med ordet konference. På Steam Hotel mødes I i et unikt industriromantisk miljø ved Mälarens bred, kun 55 minutter fra Stockholm. Ud over charmerende mødefaciliteter og forfriskninger i verdensklasse, tilbyder vi masser af aktiviteter til at opbygge team spirit. Småt eller storslået? We got you. Op til 450 personer, nul tekniske problemer og en maksimal oplevelse.</p>`
  },
  image: '/assets/images/steam.jpg',
  country: 'se',
  region: 'stockholm',
  city: 'Stockholm',
  address: 'Kraftverksgatan 14, 721 30 Västerås, Sweden',
  coordinates: {
    lat: 59.606859195899474,
    lng: 16.567652147155517
  },
  capacity: {
    min: 10,
    max: 450
  },
  rating: 4.7,
  reviews: Array.from({ length: 320 }, (_, i) => ({
    id: `review-${i}`,
    userId: `user-${i}`,
    rating: 4.7,
    comment: '',
    date: new Date().toISOString()
  })),
  amenities: ['wifi', 'coffee', 'restaurant', 'pool', 'spa', 'gym'],
  images: [
    '/assets/images/steam.jpg',
    'https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?auto=format&fit=crop&q=80&w=2000'
  ],
  priceRange: {
    min: 2500,
    max: 35000
  },
  recommended: false,
  factbox: {
    rooms: 263,
    conferenceRooms: 18,
    meetingCapacity: 450,
    features: [
      '3 restaurants',
      '263 double rooms',
      '18 conference rooms',
      'Modern technology',
      'Luggage room',
      '4 pools',
      'Playground',
      'Cinema',
      '7 bars',
      'Golf simulators',
      '10m from Lake Mälaren'
    ]
  }
}; 